import { Modal } from "antd";
import { action, computed, makeAutoObservable, runInAction } from "mobx";
import moment from "moment";
import { Api } from "../../common/Api";
import { RegionFilterStore } from "../RegionFilterStore";
import { VolunteerCancelStore } from "./VolunteerCancelStore";
import { VolunteerEditStore } from "./VolunteerEditStore";
import { VolunteerStore } from "./VolunteerStore";

export class VolunteersStore {
  filterStore: RegionFilterStore;
  editStore: VolunteerEditStore;
  viewStore: VolunteerStore;
  cancelStore: VolunteerCancelStore;

  loading = false;

  filter: any = {
    page: 0,
    size: 100,
    keyword: "",
    regionId: "",
    divisionId: "",
    communityId: "",
    status: ["Active", "Scheduled"],
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "createdAt", order: "descend" };

  data = {
    total: 0,
    items: [],
  };

  get status() {
    return [
      { id: "Scheduled", name: "Scheduled" },
      { id: "Active", name: "Active" },
      { id: "Paused", name: "Paused" },
      { id: "Expired", name: "Expired" },
      { id: "Cancelled", name: "Cancelled" },
    ];
  }

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new RegionFilterStore(this);
    this.editStore = new VolunteerEditStore(this);
    this.viewStore = new VolunteerStore(this);
    this.cancelStore = new VolunteerCancelStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: any[] = [undefined, undefined];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);

    const regionId = params.get("regionId") || "";
    const divisionId = params.get("divisionId") || "";
    const communityId = params.get("communityId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");
    const keyword = params.get("keyword") || "";
    const status = params.get("status") ? params.get("status")?.split(",") : ["Active", "Scheduled"];

    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    this.filter = { status, keyword, regionId, divisionId, communityId, period, page, size };

    this.refresh();
  }

  @action setStatus(id, pause) {
    Modal.confirm({
      content: "Are you sure?",
      onOk: () => {
        return Api.volunteer.setVolunteerStatus(id, pause).then(() => {
          setTimeout(() => this.refresh(false), 3000);
        });
      },
    });
  }

  @action onCancel(id) {
    Modal.confirm({
      content: "Are you sure?",
      onOk: () => {
        // return Api.volunteer.setVolunteerStatus(id, pause).then(() => {
        //   setTimeout(() => this.refresh(false), 3000);
        // });
      },
    });
  }

  @action
  refresh(loading = true) {
    this.loading = loading;
    const { retired, regionId, divisionId, communityId, period, keyword, page, size, status } = this.filter;
    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];
    const filter: any = {
      retired,
      regionId,
      divisionId,
      communityId,
      keyword,
      status,
      page,
      size,
      sorts,
    };

    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    return Api.volunteer
      .volunteers(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.volunteers;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }
}

export const volunteersStore = new VolunteersStore();
